import gql from 'graphql-tag'

export default gql`
  query getPriceWithCoupon(
    $serviceId: ID!
    $duration: Int!
    $code: String!
  ) {
    coupon: getPriceWithCoupon(
      serviceId: $serviceId
      duration: $duration
      code: $code
    ) {
      isValid
      message
      price
      currency
      discount
      code
    }
  }
`
